import React from "react";
import { ImSpinner3 } from "react-icons/im";

export default function LoadingSpinner() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
      }}
    >
      <ImSpinner3 className="animate-spin" color={"#ec008c"} size={25}/>
    </div>
  );
}
